(function ($) {
    $(function () {
    // Convert to sentence case
    const titleCase = [
        '#shipping_company',
        '#shipping_first_name',
        '#shipping_last_name',
        '#shipping_address_1',
        '#shipping_address_2',
        '#shipping_city',
        '#shipping_state',
        '#billing_company',
        '#billing_first_name',
        '#billing_last_name',
        '#billing_address_1',
        '#billing_address_2',
        '#billing_city',
        '#billing_state',
        '#account_first_name',
        '#account_last_name',
        '#account_address_1',
        '#account_address_2',
        '#account_city',
        '#account_state'
    ];

    titleCase.forEach((id) => {
        $(id).on('change', () => {;
            $(id).val(convertToTitleCase($(id).val()));
        })
    });

    // Convert to lower case
    const lowerCase = [
         '#w3w-shipping',
         '#w3w-billing',
    ];

    lowerCase.forEach((id) => {
        $(id).on('change', () => {
            $(id).val(convertToLowerCase($(id).val()));
        })
    });

    // Convert to upper case
    const upperCase = [
        '#postcode-popup-input',
        '#billing_postcode',
        '#shipping_postcode',
        '#idpc_input',
    ];

    upperCase.forEach((id) => {
        $(id).on('change', () => {
            $(id).val(convertToUpperCase($(id).val()));
        })
    });

    /**
     * Convert a value to sentence case
     *
     * @param value
     * @return string
     */
    const convertToTitleCase = (value) =>  {
        // Split value for processing
        let parts = value.split(' ');

        parts.forEach((part, index) => {
            // Trim and lowercase
            parts[index] = part.trim().toLowerCase();
            parts[index] = parts[index].charAt(0).toUpperCase() + parts[index].substr(1);
        });

        // Return the joined parts
        return parts.join(' ');
    };

    /**
     * Convert a value to lower case
     *
     * @param value
     * @return string
     */
    const convertToLowerCase = (value) => {
        return value.toLowerCase();
    }

    /**
     * Convert a value to upper case
     *
     * @param value
     * @return string
     */
    const convertToUpperCase = (value) => {
        return value.toUpperCase();
    }
});
})(jQuery);